import http from 'hub-http/clients/apiClient';
const API_BASE = '/knowledge-content/v1/knowledge-articles/import';
const API_CANCEL = `${API_BASE}/cancel`;
const API_PROGRESS = `${API_BASE}/progress`;
export default class ImportApi {
  static startImport({
    url,
    autoPublish,
    knowledgeBaseId
  }) {
    const query = {
      autoPublish,
      url,
      bulkImport: true,
      knowledgeBaseId
    };
    return http.post(API_BASE, {
      query
    });
  }
  static cancelImport(knowledgeBaseId) {
    return http.put(API_CANCEL, {
      query: {
        knowledgeBaseId
      }
    });
  }
  static getProgress(knowledgeBaseId) {
    return http.get(API_PROGRESS, {
      query: {
        knowledgeBaseId
      }
    });
  }
}